(function () {
  'use strict';

  /* @ngdoc object
   * @name managePairing
   * @description
   *
   */
  angular
    .module('managePairing', [
      'ui.router'
    ]);
}());
